import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { Router,NavigationExtras,ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.page.html',
  styleUrls: ['./offers.page.scss'],
})
export class OffersPage implements OnInit {
  userId:any=localStorage.getItem('userId');
  referralCount:number;
  referraPromotion:any=[];
  flag : any;
  constructor(private router: Router,private authService:StoreService,private routerActivate:ActivatedRoute,private navController : NavController) { }

  ngOnInit() {
   
  
  }
  listOfMyOffer(){
   
    const refData = {
       userId:this.userId,
      // mobile:mobileN
    } 
     console.log("send params for list of My offer",refData)
        this.authService.refferalOffers(refData).subscribe((result:any)=>{
       console.log("My offer list",result)
         // this.authService.hideLoader()
          this.referralCount=result.counter
          this.referraPromotion=result.result
          // this.toast.presentToast("Referral code sent!!")   
        }, (error: any) => {
      // this.authService.hideLoader()
       }); 
  }

  redeemOffer(promoObj:any){
 
  console.log("process to checkout",promoObj)
  let navigationParams: NavigationExtras = { state: {finalProdcutArr:promoObj}};
  this.router.navigate(['/home/checkout'], navigationParams);
}
  goBack(){
    this.navController.pop();
}
}
